var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScriptMaintenanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9458_59501",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 47
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46.5,
    height: 46.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9458_59501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6 29.1068L10.4932 23L16.6 16.8932L18.5656 18.9059L14.4715 23L18.5656 27.0941L16.6 29.1068ZM29.4 29.1068L27.4344 27.0941L31.5285 23L27.4344 18.9059L29.4 16.8932L35.5068 23L29.4 29.1068ZM10.4028 39C9.45192 39 8.64706 38.6706 7.98824 38.0118C7.32941 37.3529 7 36.5481 7 35.5972V28.6471H9.82353V35.5972C9.82353 35.7421 9.88392 35.8748 10.0047 35.9953C10.1252 36.1161 10.2579 36.1765 10.4028 36.1765H17.3529V39H10.4028ZM28.6471 39V36.1765H35.5972C35.7421 36.1765 35.8748 36.1161 35.9953 35.9953C36.1161 35.8748 36.1765 35.7421 36.1765 35.5972V28.6471H39V35.5972C39 36.5481 38.6706 37.3529 38.0118 38.0118C37.3529 38.6706 36.5481 39 35.5972 39H28.6471ZM7 17.3529V10.4028C7 9.45192 7.32941 8.64706 7.98824 7.98824C8.64706 7.32941 9.45192 7 10.4028 7H17.3529V9.82353H10.4028C10.2579 9.82353 10.1252 9.88392 10.0047 10.0047C9.88392 10.1252 9.82353 10.2579 9.82353 10.4028V17.3529H7ZM36.1765 17.3529V10.4028C36.1765 10.2579 36.1161 10.1252 35.9953 10.0047C35.8748 9.88392 35.7421 9.82353 35.5972 9.82353H28.6471V7H35.5972C36.5481 7 37.3529 7.32941 38.0118 7.98824C38.6706 8.64706 39 9.45192 39 10.4028V17.3529H36.1765Z",
    fill: "#395C9F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScriptMaintenanceIcon);
export default __webpack_public_path__ + "static/media/scriptMaintenanceIcon.51fba1dc044856c67fe9c79e31257910.svg";
export { ForwardRef as ReactComponent };